
import { FaCheck, FaTimes } from "react-icons/fa";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";

interface ForgotPasswordInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  phone: string;
};

const ForgotPasswordInfoModal = ({
  isOpen,
  onClose, 
  phone,
}: ForgotPasswordInfoModalProps) => {

  if (!isOpen) {
    return null;
  }

  return (
    <Modal overlayClassName="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-md shadow-xl p-4 relative w-full max-w-3xl">
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-primary-600 hover:text-primary-700 text-2xl font-bold"
        >
          <FaTimes />
        </button>

        <h2 className="text-md md:text-xl font-semibold mb-3">{"ESQUECEU SUA SENHA DE ACESSO?"}</h2>

        <div className="flex justify-center items-center flex-col text-center">
          <FaCheck className="text-primary-600 text-2xl md:text-3xl" />

          <p className="font-semibold mt-2 md:mt-0 text-sm md:text-md">{"RECUPERAÇÃO DE SENHA ENVIADA!"}</p>

          <p className="mt-3 text-xs md:text-sm">{`Enviamos o link para criar uma nova senha pelo WhatsApp, no número ${phone}.`}</p>
          <p className="mb-3 text-xs md:text-sm">{"Siga as instruções da mensagem para finalizar a recuperação."}</p>

          <Button 
            onClick={onClose} 
            className="block mx-auto w-full py-3"
          >
            OK
          </Button> 
        
          <p className="mt-4 text-xs md:text-sm">{"Caso não tenha mais acesso a este número, favor entrar em contato com o atendimento."}</p>
        </div>
      </div>
    </Modal>
  );
};

export default ForgotPasswordInfoModal;
